export function checkValueExists(selectedArray: any, valueToCheck: any) {
  const isIdExist = selectedArray.some((item: any) => item.id == valueToCheck)
  if (isIdExist) {
    return true
  } else {
    return false
  }
}
